import React, { Component } from "react";
import { Form, Input, DatePicker, AutoComplete, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { Dropdown } from "../../../../components/common/dropdown";
import { CarStatusType } from "../car-status-type/car-status-type";
import { apiUser } from "../../../../api/api-users";

const { TextArea } = Input;
const { Option } = AutoComplete;
const antIcon = <LoadingOutlined style={{ fontSize: 22 }} spin />;

export class CarManagement extends Component {
  timeout = null;
  currentValue = "";
  totalPage = 1;
  page = 1;

  constructor(props) {
    super(props);
    this.state = {
      operation_admins: [],
      operation_admin_id: null,
      unit_operators: [],
      unit_operator_id: null,
      accountants: [],
      accountant_id: null,
      in_current_journey_diary: false,
      in_current_contract: false,
      carStatus: 1,
    };
  }

  onSearch = (data, type) => {
    var self = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.page = 1;

    this.currentValue = data;
    this.onChangeFormValues({
      name: data.toUpperCase(),
    });
    if (!data) {
      this.setState({
        operation_admins: [],
        unit_operators: [],
        accountants: [],
      });
      return;
    }

    async function searchData() {
      let func = apiUser.getUsers;
      let filters = {
        branch: {
          code: null,
        },
        code: null,
        created_by: {
          name: null,
        },
        department: {
          id: type === "operation_admin" ? 1 : type === "unit_operator" ? 2 : 3,
        },
        name: `%${data
          .trim()
          .replace(/(\r\n|\n|\r)/gm, " ")
          .replace(/%/gi, "\\%")}%`,
        active: true,
      };
      try {
        const result = await func(filters, 1);
        if (result.status === "success") {
          self.totalPage = result.data.totalPages;
          if (self.currentValue !== data) {
            return;
          }
          if (type === "operation_admin") {
            self.setState({
              operation_admins: result.data.content.map((suggestion) => {
                return {
                  ...suggestion,
                  value: suggestion.name,
                };
              }),
            });
          } else if (type === "unit_operator") {
            self.setState({
              unit_operators: result.data.content.map((suggestion) => {
                return {
                  ...suggestion,
                  value: suggestion.name,
                };
              }),
            });
          } else {
            self.setState({
              accountants: result.data.content.map((suggestion) => {
                return {
                  ...suggestion,
                  value: suggestion.name,
                };
              }),
            });
          }
        }
      } catch (error) {}
    }

    this.timeout = setTimeout(searchData, 300);
  };

  onSelect = (item, type) => {
    const { data } = item;
    this.currentValue = data.name;
    this.page = 1;
    this.totalPage = 1;
    if (type === "operation_admin") {
      this.setState({ operation_admins: [data], operation_admin_id: data.id });
      let values = {
        operation_admin: data.name,
      };
      this.onChangeFormValues(values);
    } else if (type === "unit_operator") {
      this.setState({ unit_operators: [data], unit_operator_id: data.id });
      let values = {
        unit_operators: data.name,
      };
      this.onChangeFormValues(values);
    } else {
      this.setState({ accountants: [data], accountant_id: data.id });
      let values = {
        accountants: data.name,
      };
      this.onChangeFormValues(values);
    }
  };

  onChangeFormValues = (values) => {
    const { onChangeFormValues } = this.props;
    onChangeFormValues({ ...values });
  };

  loadMoreFunc = async () => {
    let func = apiUser.getUsers;
    const data = this.currentValue;
    let filters = {
      branch: {
        code: null,
      },
      code: null,
      created_by: {
        name: null,
      },
      department: {
        id: 1,
      },
      name: `%${data
        .trim()
        .replace(/(\r\n|\n|\r)/gm, " ")
        .replace(/%/gi, "\\%")}%`,
      active: true,
    };
    try {
      this.setState({ isLoadMore: true });
      const result = await func(filters, this.page);

      if (result.status === "success") {
        this.totalPage = result.data.totalPages;
        this.setState(
          {
            operation_admins: this.state.operation_admins.concat(
              result.data.content.map((suggestion) => {
                return {
                  ...suggestion,
                  value: suggestion.name,
                };
              })
            ),
          },
          () => this.setState({ isLoadMore: false })
        );
      } else {
        this.setState({ isLoadMore: false });
      }
    } catch (error) {
      this.setState({ isLoadMore: false });
    }
  };

  suggestionRender = (data) => {
    let loadMore = false;
    loadMore = this.totalPage > this.page;

    const { isLoadMore } = this.state;

    return (
      <>
        {data.map((item) => {
          return (
            <Option
              data={item}
              style={styles.selectOptoption}
              key={item.id}
              value={item.value}
            >
              <div style={styles.container}>
                <div
                  style={{ overfloWrap: "break-word", whiteSpace: "pre-wrap" }}
                >
                  {item.name} - {item.code}
                </div>
              </div>
            </Option>
          );
        })}
        {data.length > 0 && loadMore && !isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div
              onClick={() => {
                this.page++;
                this.loadMoreFunc();
              }}
              style={styles.loadmore}
            >
              Loadmore
            </div>
          </Option>
        )}
        {isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div style={styles.loadmoreLoading}>
              <Spin indicator={antIcon} />
            </div>
          </Option>
        )}
      </>
    );
  };

  onChangeName = (data) => {
    this.onChangeFormValues({
      name: data.toUpperCase(),
    });
  };

  render() {
    const { editable, typeOption, editPage } = this.props;
    const {
      operation_admins,
      unit_operators,
      accountants,
      in_current_contract,
      in_current_journey_diary,
      carStatus,
    } = this.state;
    return (
      <>
        <Form.Item name="car_status" label="* Trạng thái của xe::" rules={[]}>
          <CarStatusType
            typeOption={typeOption}
            in_current_contract={in_current_contract}
            in_current_journey_diary={in_current_journey_diary}
            status={carStatus}
            disabled={!editable}
          />
        </Form.Item>
        <Form.Item
          name="liquidation_date"
          className="alignment"
          label="Ngày thanh lý::"
          rules={[]}
        >
          <DatePicker
            disabled={!editable}
            // inputReadOnly
            dropdownClassName="date-picker-dropdown-top"
            getPopupContainer={(node) => {
              if (node) {
                return node.parentNode;
              }
              return document.body;
            }}
            format="DD/MM/YYYY"
            className="dropdown-full"
          />
        </Form.Item>
        <Form.Item
          name={"operation_admin"}
          label="* Admin điều hành::"
          rules={[
            {
              required: true,
              message: `Vui lòng nhập Admin điều hành!`,
            },
          ]}
        >
          <AutoComplete
            placeholder="Admin điều hành"
            disabled={!editable}
            getPopupContainer={(node) => {
              if (node) {
                return node.parentNode;
              }
              return document.body;
            }}
            ref={(ref) => (this.auto = ref)}
            defaultActiveFirstOption={false}
            onSearch={(data) => this.onSearch(data, "operation_admin")}
            onSelect={(data, option) =>
              this.onSelect(option, "operation_admin")
            }
          >
            {this.suggestionRender(operation_admins)}
          </AutoComplete>
        </Form.Item>
        <Form.Item
          name={"unit_operator"}
          label="* Điều hành khối::"
          rules={[
            {
              required: true,
              message: `Vui lòng nhập Điều hành khối!`,
            },
          ]}
        >
          <AutoComplete
            placeholder="Điều hành khối"
            disabled={!editable}
            getPopupContainer={(node) => {
              if (node) {
                return node.parentNode;
              }
              return document.body;
            }}
            ref={(ref) => (this.auto = ref)}
            defaultActiveFirstOption={false}
            onSearch={(data) => this.onSearch(data, "unit_operator")}
            onSelect={(data, option) => this.onSelect(option, "unit_operator")}
          >
            {this.suggestionRender(unit_operators)}
          </AutoComplete>
        </Form.Item>
        <Form.Item
          name={"accountant"}
          label="* Kế toán::"
          rules={[
            {
              required: true,
              message: `Vui lòng nhập Kế toán!`,
            },
          ]}
        >
          <AutoComplete
            placeholder="Kế toán"
            disabled={!editable}
            getPopupContainer={(node) => {
              if (node) {
                return node.parentNode;
              }
              return document.body;
            }}
            ref={(ref) => (this.auto = ref)}
            defaultActiveFirstOption={false}
            onSearch={(data) => this.onSearch(data, "accountant")}
            onSelect={(data, option) => this.onSelect(option, "accountant")}
          >
            {this.suggestionRender(accountants)}
          </AutoComplete>
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name={"note"}
          className="note alignment"
          label="Ghi chú"
        >
          <TextArea
            disabled={!editable}
            style={{ height: "70px !important" }}
            rows={8}
          />
        </Form.Item>
      </>
    );
  }
}

export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: 35,
  },
  contract_contained: {
    fontSize: "10px",
    color: "#f4bc2b",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
  icon: {
    fontSize: "0.9em",
    marginRight: 3,
    color: "#f4bc2b",
  },
  mainTitle: {
    fontSize: "0.93em",
    color: "#000",
    fontWeight: "500",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    //lineHeight: '10px'
  },

  selectOptoption: {
    borderBottom: "0.3px solid #d9d9d9",
    position: "relative",
  },
  loadmore: {
    color: "#3a7be2",
    position: "absolute",
    bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    padding: "0px 10px",
    zIndex: 9999,
    marginBottom: "5px",
  },
  loadmoreOption: {
    padding: "0px 4px",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
  loadmoreLoading: {
    display: "flex",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "0px 10px",
    marginBottom: "5px",
    zIndex: 9999,
  },
};
